import { Route, Routes } from "react-router-dom";

import Landing from "#/pages/profile/Landing";
import Layout from "#/pages/profile/Layout";

export default function ProfileRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
      </Route>
    </Routes>
  );
}
